module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ed-switch"
  }, [_c('button', {
    staticClass: "ed-switch__part ed-btn-squared",
    class: {
      'ed-u-color-primary': _vm.thisList, 'ed-switch--disabled': _vm.thisList
    },
    on: {
      "click": _vm.changeViewList
    }
  }, [_vm._t("view1")], 2), _vm._v(" "), _c('button', {
    staticClass: "ed-switch__part ed-btn-squared",
    class: {
      'ed-u-color-primary': !_vm.thisList, 'ed-switch--disabled': !_vm.thisList
    },
    on: {
      "click": _vm.changeViewNotList
    }
  }, [_vm._t("view2")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-673253d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/edoc-library/src/components/switchView/switchView.vue
// module id = 702
// module chunks = 42